module.exports = __webpack_public_path__ + "static/media/contract.f56de18f.svg";